import type { FormSubmissionResponse } from '@qdf/shared';
import { FormLayout } from '../layout/FormLayout.js';
import { NwIntakeForm } from './NwIntakeForm.js';

interface NwIntakePageProps {
  onSuccess: (response: FormSubmissionResponse) => void;
}

export function NwIntakePage({ onSuccess }: NwIntakePageProps) {
  return (
    <FormLayout
      title="Apply for Funding"
      subtitle="Complete the form below to apply for a line of credit with New Western. Fields marked with * are required."
    >
      <NwIntakeForm onSuccess={onSuccess} />
    </FormLayout>
  );
}
